// extracted by mini-css-extract-plugin
export default {"paymentHistory":"PaymentTransactionModal_paymentHistory__btoUa"};